import LinkPrevue from './LinkPrevue.vue'

export default LinkPrevue



// WEBPACK FOOTER //
// ./src/index.js